import { Component, OnDestroy, OnInit, Type, signal } from "@angular/core";
import { Router } from "@angular/router";
import { DynamicDialogRef } from "primeng/dynamicdialog";

enum SaveOptionsEnum {
    NewMajorVersion = 0,
    NewDesign = 1
}

export enum DialogState {
    SaveFormOnNoBreakingChanges,
    DiscardChanges,
    SaveANewMajorVersion
}

@Component({
    selector: "bb-form-save-dialog",
    templateUrl: "./bb-form-save-dialog.component.html"
})
export class BBFormSaveDialogComponent {

    // Setting state to null will show the Spinner
    public state = signal<DialogState>(DialogState.SaveFormOnNoBreakingChanges);

    get dialogState() {
        return DialogState;
    } 

    public designName = "";

    public saveOptionType: SaveOptionsEnum = null;

    get isSaveButtonDisabled() {
        if (this.saveOptionType == null || (this.saveOptionType == SaveOptionsEnum.NewDesign && this.designName == "")) {
            return true;
        }

        return false;
    }

    constructor(private ref: DynamicDialogRef,  private router: Router) {}

    saveFormOnNoBreakingChanges() {
        this.ref.close(DialogState.SaveFormOnNoBreakingChanges);
        this.router.navigate(["/app/formio/list"]);
    }
    showDiscardChangesOptionHandler = () => {
        this.showSpinner();
        this.setDialogState(DialogState.DiscardChanges);       
    }

    onYesDiscardChangesHandler = () => this.ref.close(DialogState.DiscardChanges);

    onNoDiscardChangesHandler = () => {
        this.showSpinner();
        this.setDialogState(DialogState.SaveANewMajorVersion);
    }

    save = () => {
        if (this.saveOptionType == SaveOptionsEnum.NewMajorVersion) {
            return this.ref.close(DialogState.SaveANewMajorVersion);
        }

        // Save new form definition
        this.router.navigate(["/app/formio/list"]);
        return this.ref.close(this.designName);
    }

    private showSpinner = () => this.state.set(null);

    private setDialogState = (state: DialogState) => setTimeout(() => this.state.set(state), 500);

}